import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { swapLocaleInPath, type Locale } from './locales';
import { persistLocale } from '@/stores/actions';

/** Language switch: rewrites /:lang in the URL (keeps path/query/hash), saves to localStorage and profile. */
export function useSwitchLocale(): (l: Locale) => void {
  const navigate = useNavigate();
  const loc = useLocation();
  return useCallback(
    (l: Locale) => {
      persistLocale(l);
      navigate(swapLocaleInPath(loc.pathname, l) + loc.search + loc.hash);
    },
    [navigate, loc.pathname, loc.search, loc.hash],
  );
}
